import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export enum DataSourceType {
    GOOGLE_ANALYTICS = 'google_analytics',
    GOOGLE_ADWORDS = 'google_adwords',
    FACEBOOK = 'facebook'
}

export class DataSource extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Client' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    type: DataSourceType;

    @JsonProperty({ type: 'Date' })
    created_at: Date;
}



// WEBPACK FOOTER //
// ./src/api/models/datasource.ts